<template>
  <page-status class="order-detail" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="订单信息" />
      </van-cell>
      <van-cell title="订单号">{{ detail.cashierId }}</van-cell>
      <van-cell title="投保人姓名">{{ detail.applicantName }}</van-cell>
      <van-cell title="投保人身份证号码">{{ detail.applicantCertNo }}</van-cell>
      <van-cell title="最后缴费日期">{{ detail.lastPayDate }}</van-cell>
      <van-cell title="费用合计">{{ detail.sumPayFee }}元</van-cell>
    </van-cell-group>

    <van-cell-group
      style="margin-top: 12px"
      v-for="(order, index) in detail.payOrderDetails"
      :key="index"
    >
      <van-cell v-if="index === 0">
        <cell-header slot="title" title="投保单信息" />
      </van-cell>
      <van-cell title="投保单号">{{ order.bizNo }}</van-cell>
      <van-cell title="保费/车船税" v-if="order.classType === '1'"
        >{{ order.premium }}元/{{ order.vehicleTax }}元</van-cell
      >
      <van-cell title="保费" v-else>{{ order.premium }}元</van-cell>
      <van-cell title="被保险人姓名">{{ order.insuredName }}</van-cell>
      <van-cell title="车牌号">{{
        order.vehicleLicensePlateNo || '新车未上牌'
      }}</van-cell>
    </van-cell-group>

    <div class="submit-action">
      <van-button class="submit-btn" block type="info" @click="onGoPay">
        实名认证并支付
      </van-button>
    </div>

    <page-footer />
  </page-status>
</template>

<script>
import * as qs from 'qs';

import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import * as services from '@/services';
import { Toast } from 'vant';

export default {
  name: 'NewOrderDetail',
  components: {
    PageStatus,
    CellHeader,
    PageFooter,
  },

  data() {
    return {
      loading: true,
      detail: {
        orderDetailes: [],
      },
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { cashierId } = this.$route.query;

      services
        .payOrderQuery({ cashierId })
        .then(res => {
          if (res.status === 'EXCEPTION' || res.status === 'FAILED') {
            Toast.fail(res.failCause);
            return;
          }
          if (res.content) {
            this.detail = res.content;
            this.order = res.content.payOrderDetails;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onGoPay() {
      const { cashierId } = this.$route.query;
      const {
        payChannelCode,
        realNameAuth,
        showPayResultCallBackUrl,
        cashDeskRedirectUrl,
      } = this.detail;
      const search = qs.stringify({
        cashId: cashierId,
        payChannelCode,
        realNameAuth,
        originUrl: showPayResultCallBackUrl,
      });
      const host = window.location.host;
      const url = cashDeskRedirectUrl;
      window.location.href = [url, search].join('?');
    },
  },
};
</script>
<style lang="less">
.order-detail {
  .submit-action {
    margin: 32px 16px 0;
  }
}
</style>
